import React from "react";
import { useDetailsContext } from "../details";

import {
    unitLabels,
    togglePreferredUnit,
  } from "../../../services";

import {
    trackAction,
  } from "../../../services/mixpanel"

import { ReactComponent as RulerSvg } from '../../assets/fa-solid_ruler-combined.svg';

export const UnitsToggler = () => {
    const [state, dispatch] = useDetailsContext();

    const handleChangePreferredUnit = (e) => {
        // console.log(state.userPrefUnits);
        togglePreferredUnit();
        // console.log(state.userPrefUnits);
        const newLabels = unitLabels();
        // console.log(newLabels);
        dispatch({ type: 'SET_PREF_UNITS', payload: newLabels });
        // console.log("changed preferred units to: " + state.userPrefUnits);
        trackAction("Change preferred unit", state.allowedCookies);
      };
    
    return (
        <div
            title="Units"
            id="units-button"
            className="btn btn-light control-button activity-buttons-more"
            onClick={() => {handleChangePreferredUnit()}}>
            <i className="activity_icons"><RulerSvg /></i>
            ({state.userPrefUnits[1]} / {state.userPrefUnits[2]})
        </div>
    );
  }